import React, { ReactElement, useEffect, useState } from 'react';
import { Headline, Text } from '../../../../../components';
import './style.css';

// Handles the actual display of search results.
export default function SearchResults({ searchQuery }: any): ReactElement {
  // By default we only want to show the first 11 search results.
  // const [resultsOffset, setResultsOffset] = useState<number>(0);
  // const [resultsEnd, setResultsEnd] = useState<number>(11);
  const [results, setResults] = useState<any>([]);
  const [isSearching, setIsSearching] = useState<boolean>(true);

  useEffect(() => {
    async function fetchSearchResults() {
      let response = await fetch(
        `/.netlify/functions/search-knowledge-center?query=${searchQuery}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      response = await response.json();
      setResults(response.data['library-posts']);
      setIsSearching(false);
    }

    fetchSearchResults();
  }, [searchQuery]);

  return (
    <>
      {!isSearching && (
        <div className="mb-8 flex items-center justify-between border-b border-solid border-b-neutral-gray-100 pb-8">
          <Headline level="2">Search results for “{searchQuery}”</Headline>

          <Text level="mono" className="t-color-purple ml-4 whitespace-nowrap">
            {results.length} {results.length === 1 ? 'RESULT' : 'RESULTS'}
          </Text>
        </div>
      )}

      {isSearching ? (
        <div className="mb-8 border-b border-solid border-b-neutral-gray-100 pb-8">
          <Headline level="2" className="library__search-loading ">
            Searching for “{searchQuery}”...
          </Headline>
        </div>
      ) : results?.length > 0 ? (
        <div>
          <ul className="library__search-results">
            {results.map((post) => (
              <li key={post.url} className="library__search-result mb-16">
                <a
                  href={post.url}
                  target="_blank"
                  className="library__search-result__wrapper">
                  <Text
                    level="mono"
                    className="library__search-result__title uppercase">
                    <span className="t-color-purple">{post.title}</span>
                  </Text>
                  {/*
                  // NEED TO FIND A WAY TO BRING THE CATEGORY INTO THE SEARCH RESULTS
                  <Label
                    level="mono"
                    className="library__search-result__title uppercase">
                    <span className="t-color-purple">{post.category}</span>

                    <span>{` // `}</span>

                    <span>{post.title}</span>
                  </Label> */}

                  <Text className="mt-2">{post.description}</Text>
                </a>
              </li>
            ))}
          </ul>

          {/*
          // Will disable for now since we are only returning a handful of results
          // to ensure we aren't taxing our strapi instance
          <div className="flex justify-center">
            <Button
              isDisabled={resultsOffset === 0}
              buttonType="secondary"
              size="small"
              onClick={() => {
                setResultsOffset(resultsOffset + 12);
                setResultsEnd(resultsEnd + 12);
                if (typeof window !== undefined) {
                  window.scrollTo(0, 0);
                }
              }}>
              Prev
            </Button>

            <Button
              isDisabled={
                results.length < 10 || resultsOffset + 10 > results.length
              }
              className="ml-4"
              buttonType="secondary"
              size="small"
              onClick={() => {
                setResultsOffset(resultsOffset - 12);
                setResultsEnd(resultsEnd - 12);
                if (typeof window !== undefined) {
                  window.scrollTo(0, 0);
                }
              }}>
              Next
            </Button>
          </div> */}
        </div>
      ) : (
        <div className="library__search-results__none-found mt-16 flex items-center justify-between">
          <div className="library__search-results__none-found__text">
            <Text level="mono" color="purple" className="mb-4">
              Whoops
            </Text>

            <Headline level="2">We couldn’t find any matches.</Headline>

            <Text className="mb-8 mt-6">
              Try another keyword or phrase and we’ll find what you’re looking
              for.
            </Text>
          </div>

          <img
            src="https://images.getstark.co/marketing/library/empty-state-search.png"
            height={362}
            width={300}
            alt="A magnifying glass with illustrated squiggles"
          />
        </div>
      )}
    </>
  );
}
